
    require("/codebuild/output/src3366094767/src/$_mfplugin_virtualInitConfig/index.js")
    
;
    // async boundary so module federation can resolve shared deps (react, react-dom) before the app boots
import('./bootstrap');export{};
    